import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./pints-for-patriots.css";
import "../turkeydrop/turkeydrop2025/turkeydrop2025.css";
import ShieldIMG from "../../assets/rhp-shield.png";
import ShieldFooterIMG from "../../assets/shield.png";
import { CHOW_CALL_EVENTS } from "../chow-call/chowCallEvents";
import { PINTS_EVENTS } from "../pints/pintsEvents";

const DONATE_URL = "https://give.rush.edu/campaign/694982/donate";

function buildInternalLink(pathname, search) {
  return {
    pathname,
    search: search || "",
  };
}

const VENUES = [PINTS_EVENTS.horseThief, PINTS_EVENTS.openOutcry];

export default function PintsForPatriotsPage() {
  const location = useLocation();
  const chowCallEvent = CHOW_CALL_EVENTS.vfw981;
  const chowCallLink = buildInternalLink("/chow-call-vfw981", location.search);

  useEffect(() => {
    document.title = "Pints for Patriots";
  }, []);

  return (
    <>
      <main className="tdp-shell pfp-shell">
        <div
          className="tdp-bg"
          style={{ "--bg-url": `url(${ShieldIMG})` }}
          aria-hidden="true"
        />

        <section className="tdp-left pfp-left">
          <span className="crumb">Road Home Program Fundraiser</span>
          <h1 className="tdp-title pfp-title">Pints for Patriots</h1>
          <p className="pfp-subtitle">Fundraiser Concluded</p>
          <p className="tdp-sub pfp-intro">
            Pints for Patriots has concluded. Thank you to everyone who came out, raised a glass,
            and supported the Road Home Program.
          </p>
          <p className="tdp-sub pfp-intro">
            Your support still makes a difference. Donations help the Road Home Program provide
            no-cost, evidence-based mental health care to veterans, service members, and their
            families.
          </p>

          <div className="pfp-actions">
            <a
              className="tdp-submit pfp-primary-cta"
              href={DONATE_URL}
              target="_blank"
              rel="noreferrer"
            >
              Donate to Road Home
            </a>
            <Link className="tdp-ghost-btn" to={chowCallLink} style={{ textDecoration: "none" }}>
              See Our Next Event: Chow Call
            </Link>
          </div>

          <div className="tdp-block pfp-highlight">
            <h3>Support continues beyond this fundraiser</h3>
            <p className="tdp-sub" style={{ marginTop: 0 }}>
              Donations help the Road Home Program continue delivering no-cost, evidence-based
              care to veterans, service members, and their families.
            </p>
          </div>
        </section>

        <section className="tdp-right">
          <article className="tdp-card pfp-sidecard">
            <p className="pfp-sidecard__eyebrow">Next Up</p>
            <h2 className="tdp-card-title">{chowCallEvent.title}</h2>
            <p className="tdp-card-sub">{chowCallEvent.subtitle}</p>
            <div className="pfp-sidecard__promo">
              {chowCallEvent.webBanner ? (
                <img
                  src={chowCallEvent.webBanner}
                  alt={`${chowCallEvent.venueName} web banner`}
                  className="pfp-promo-card__image"
                />
              ) : null}
              <div className="pfp-sidecard__venue">
                <strong>{chowCallEvent.title}</strong>
                <span>{chowCallEvent.dateLabel}</span>
                <span>{chowCallEvent.timeLabel}</span>
                <span>{chowCallEvent.venueName}</span>
                <span>{chowCallEvent.addressLines[0]}</span>
                <span>{chowCallEvent.addressLines[1]}</span>
                <span>Partner: {chowCallEvent.partnerName}</span>
                <span>Audience: {chowCallEvent.audienceLabel}</span>
              </div>
            </div>
            <Link className="tdp-submit" to={chowCallLink} style={{ display: "inline-flex" }}>
              See Our Next Event: Chow Call
            </Link>
          </article>
        </section>
      </main>

      <section className="pfp-venues" aria-label="Pints for Patriots locations">
        <div className="pfp-venues__inner">
          <div className="pfp-venues__header">
            <p className="pfp-venues__eyebrow">Concluded Locations</p>
            <h2>Pints for Patriots has ended.</h2>
            <p>
              These brewery pages remain available for reference, but RSVPs are closed and the
              event is no longer active.
            </p>
          </div>

          <div className="pfp-venues__grid">
            {VENUES.map((venue) => (
              <article key={venue.key} className="pfp-venue-card">
                <img
                  src={venue.webBanner}
                  alt={`${venue.venueName} banner`}
                  className="pfp-venue-card__image"
                />
                <div className="pfp-venue-card__body">
                  <p className="pfp-venue-card__kicker">Concluded on May 21, 2026</p>
                  <h3>{venue.venueName}</h3>
                  <p className="pfp-venue-card__address">
                    {venue.addressLines[0]}
                    <br />
                    {venue.addressLines[1]}
                  </p>
                  <p>
                    This Pints for Patriots location event has concluded. Thank you for supporting
                    the Road Home Program.
                  </p>
                  <div className="pfp-venue-card__actions">
                    <Link to={{ pathname: venue.path, search: location.search || "" }}>
                      View Concluded Location Page
                    </Link>
                    <Link to={chowCallLink}>See Our Next Event: Chow Call</Link>
                    <a href={DONATE_URL} target="_blank" rel="noreferrer">
                      Donate to Road Home
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <footer className="tdp-footer" role="contentinfo">
        <div className="tdp-footer__inner">
          <div className="tdp-footer__brand">
            <img
              src={ShieldFooterIMG}
              alt=""
              aria-hidden="true"
              className="tdp-footer__shield"
              decoding="async"
            />
            <div className="tdp-footer__brandtext">
              <div className="tdp-footer__title">Road Home Program</div>
              <div className="tdp-footer__org">
                The National Center of Excellence for Veterans and Their Families at Rush
              </div>
              <div className="tdp-footer__contact">
                1645 W. Jackson Blvd., Suite 602, Chicago, IL 60612
                <span className="tdp-dot" aria-hidden>
                  •
                </span>
                <a href="tel:13129428387">(312) 942-8387 (VETS)</a>
              </div>
            </div>
          </div>

          <nav className="tdp-footer__nav" aria-label="Footer">
            <a href="https://roadhomeprogram.org/family-center/">Help for Families</a>
            <a href="https://roadhomeprogram.org/get-care/">Get Care</a>
            <a href="https://roadhomeprogram.org/accelerated-treatment-program/">
              Accelerated Treatment Program
            </a>
            <a href="https://roadhomeprogram.org/outpatient-program/">Outpatient Program</a>
            <a href="https://roadhomeprogram.org/outreach-and-events/">Outreach and Events</a>
            <a href="https://roadhomeprogram.org/contact-us/">General Information</a>
          </nav>

          <div className="tdp-footer__legal">
            © {new Date().getFullYear()} Road Home Program at Rush.
          </div>
        </div>
      </footer>
    </>
  );
}
